var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLbIconUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "profile-2user"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M6.21667 7.24667C6.15 7.24 6.07 7.24 5.99667 7.24667C4.41 7.19333 3.15 5.89333 3.15 4.29333C3.15 2.66 4.47 1.33333 6.11 1.33333C7.74334 1.33333 9.07 2.66 9.07 4.29333C9.06334 5.89333 7.80334 7.19333 6.21667 7.24667Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M10.94 2.66667C12.2333 2.66667 13.2733 3.71333 13.2733 5C13.2733 6.26 12.2733 7.28667 11.0267 7.33333C10.9733 7.32667 10.9133 7.32667 10.8533 7.33333",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M2.77333 9.70667C1.16 10.7867 1.16 12.5467 2.77333 13.62C4.60667 14.8467 7.61333 14.8467 9.44667 13.62C11.06 12.54 11.06 10.78 9.44667 9.70667C7.62 8.48667 4.61333 8.48667 2.77333 9.70667Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M12.2267 13.3333C12.7067 13.2333 13.16 13.04 13.5333 12.7533C14.5733 11.9733 14.5733 10.6867 13.5333 9.90667C13.1667 9.62667 12.72 9.44 12.2467 9.33333",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "Vector_5",
  opacity: 0
}))));
export default SvgLbIconUsers;